import React from 'react';

import { Mobile } from './Mobile';
import { Desktop } from './Desktop';

export const Private: React.FC = ({ children }) => {
  const isMobile = window.innerWidth <= 852;

  if (isMobile) {
    console.log('>>> Private:isMobile', isMobile, window.innerWidth);
    return <Mobile>{children}</Mobile>;
  }

  return <Desktop>{children}</Desktop>;
};
